const businessmagedit = {
  path: 'businessmagedit/:merchantId',
  component: resolve => require(['@/pages/admin/businessmag/edit'], resolve),
  meta: {
    requireAuth: true
  }
}

export default businessmagedit
